import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';
import { colors, fonts, animate } from '../styles/theme';
import { Icon } from '../ui_elements';
import { Input } from '../form';
import {
  navItemColor,
  navAccentColor,
  navItemHoverBgColor,
  navPlainTextColor,
  navActiveItemColor,
} from './theme-nav';

const SearchIcon = styled(Icon)`
  left: 100%;
  line-height: 49px;
  margin-left: -50px;
  pointer-events: none;
  position: absolute;
  text-align: center;
  top: 0;
  transition: left ${animate.transition} linear;
  width: 40px;
  &:before {
    font-size: 18px;
  }
  @media screen and (max-width: 1000px) {
    left: 0;
    margin: 0;
    line-height: 30px;
    &:before {
      font-size: 14px;
    }
  }
`;

const SearchInput = styled(Input)`
  border: 0;
  box-shadow: none;
  font-size: 14px;
  min-height: 0;
  outline: none;
  margin: 0;
  background: none;
  height: 49px;
  padding-left: 40px;
  transition: opacity ${animate.transition} linear;
  color: ${navItemColor};
  font-weight: ${fonts.sans.weight.bold};
  &::placeholder {
    color: ${navPlainTextColor};
    font-weight: ${fonts.sans.weight.normal};
  }
  &:hover {
    cursor: text;
  }
  &:focus {
    border: 0;
  }
  &[value=''] {
    opacity: 0;
  }
  &:not([value='']) {
    & + ${SearchIcon} {
      color: ${navActiveItemColor};
      left: 0;
      margin: 0;
    }
  }
  @media screen and (min-width: 1000px) {
    background: ${navItemHoverBgColor};
  }
  @media screen and (max-width: 1000px) {
    height: 30px;
    padding-left: 30px;
  }
`;

const SearchInnerWrapper = styled('div')`
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 1000px) {
    display: block;
    overflow: visible;
    margin-top: 7px;
  }
`;

const SearchWidthWrapper = styled('div')`
  max-width: 500px;
  min-width: 50%;
  position: relative;
`;

const SearchWrapper = styled('form')`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  margin: 0 10px;
  border-right: 1px solid ${navAccentColor};
  ${SearchIcon} {
    color: ${navItemColor};
    width: 30px;
  }
  &:hover,
  &:focus {
    ${SearchInput} {
      @media screen and (min-width: 1000px) {
        background: ${navItemHoverBgColor};
        opacity: 1;
      }
    }
    ${SearchIcon} {
      color: ${navActiveItemColor};
      left: 0;
      margin: 0;
    }
  }
  @media screen and (max-width: 1000px) {
    display: block;
    order: ${(props) => props.mobileorder};
    flex-grow: 0;
    padding-bottom: 10px;
    border-right: 0;
    margin: 0;
    ${SearchIcon},
    ${SearchInput},
    &:hover ${SearchIcon},
    &:focus ${SearchIcon},
    ${SearchInput}:not([value=""]) + ${SearchIcon} {
      color: ${colors.grey.primaryLight};
    }
    ${SearchInput}[value=""] {
      opacity: 1;
    }
  } ;
`;
class NavSearch extends Component {
  constructor(props) {
    super(props);
    this.state = { term: '' };
  }

  handleChange = (evt) => {
    this.setState({ term: evt.target.value });
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    const { onSearch } = this.props;
    const { term } = this.state;
    onSearch(term);
  };

  render() {
    const { term } = this.state;
    const { placeholder, mobileorder, onSearch } = this.props;

    if (onSearch === 'undefined') return <SearchWrapper onSubmit={null} mobileorder={null} />;

    return (
      <SearchWrapper onSubmit={this.handleSubmit} mobileorder={mobileorder}>
        <SearchInnerWrapper>
          <SearchWidthWrapper>
            <SearchInput
              name="query"
              placeholder={placeholder}
              onChange={this.handleChange}
              value={term}
              autoComplete="off"
            />
            <SearchIcon type="search" />
          </SearchWidthWrapper>
        </SearchInnerWrapper>
      </SearchWrapper>
    );
  }
}

NavSearch.defaultProps = {
  mobileorder: '',
};

NavSearch.propTypes = {
  onSearch: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  placeholder: PropTypes.string.isRequired,
  mobileorder: PropTypes.string,
};

export default NavSearch;
